import { AutoCompleteFilters, AutoCompleteSearch } from "Explore/Components";
import { IconPack } from "Explore/Config/Icons";
import { Badge, Drawer } from "antd";
import { useEffect, useMemo, useState } from "react";
import styles from "./FiltersVenueMobile.module.scss";
import { getSuggestSearchConcepts } from "Explore/Services/Concept";
import { getSuggestSearchVenues } from "Explore/Services/Venue";
import useFilterAndPagination from "Hooks/useFilterAndPagination";
import {
  DEFAULT_SEARCH_PARAMS,
  ParamsFilterKey,
} from "Config/filterSearchParams";
import FiltersVenue from "../FiltersVenue";

const FiltersVenueMobile = () => {
  const { filter, updateSearchParams } = useFilterAndPagination();
  const [open, setOpen] = useState(false);
  const [tempFilters, setTempFilters] = useState(filter);

  const totalFilterApplied = useMemo(
    () =>
      Object.keys(filter).reduce((total, key) => {
        let _total = total;
        if (!!filter[key]) {
          if (Array.isArray(filter[key])) {
            _total += filter[key].length;
          } else if (filter[key] !== DEFAULT_SEARCH_PARAMS[key]) {
            _total += 1;
          }
        }
        return _total;
      }, 0),
    [filter]
  );

  useEffect(() => {
    setTempFilters(filter);
  }, [filter]);

  const onClose = () => {
    setOpen(false);
    setTempFilters(filter);
  };
  const showDrawer = () => {
    setOpen(true);
  };
  const onApplyFilters = () => {
    updateSearchParams(tempFilters);
    setOpen(false);
  };
  const onClearFilters = () => {
    setTempFilters(DEFAULT_SEARCH_PARAMS);
  };
  return (
    <div className={styles["filters-venue-mobile"]}>
      {/* <AutoCompleteSearch
        placeholder={"Search by venue name"}
        functionSearch={getSuggestSearchVenues}
        filters={filter}
        setFilters={updateSearchParams}
        entity={filter[ParamsFilterKey.QUERY]}
      /> */}
      <Badge count={totalFilterApplied}>
        <div className={styles["filter-trigger"]} onClick={showDrawer}>
          {IconPack.menuIcon}
        </div>
      </Badge>

      <Drawer
        title="Venue Filters"
        placement={"bottom"}
        closable={true}
        onClose={onClose}
        open={open}
        key={"bottom"}
        height={"90%"}
        zIndex={1001}
        footer={
          <div className={styles["filters-footer"]}>
            <button
              className={styles["clear-button"]}
              onClick={() => onClearFilters()}
            >
              Clear
            </button>
            <button
              className={styles["apply-button"]}
              onClick={() => onApplyFilters()}
            >
              Apply
            </button>
          </div>
        }
      >
        <FiltersVenue filter={tempFilters} updateFilter={setTempFilters} />
      </Drawer>
    </div>
  );
};

export default FiltersVenueMobile;
